module.exports = __webpack_public_path__ + "media/icons/key-cmd-enter-d14ef5b9.svg";